module.exports = __webpack_public_path__ + "static/AL.190207.COH.WEBW.BOC-166b013930cd8b7619348bea2d20fc21.png";